import { render, staticRenderFns } from "./IconCalls.vue?vue&type=template&id=b6ad9716&scoped=true"
import script from "./IconCalls.vue?vue&type=script&lang=js"
export * from "./IconCalls.vue?vue&type=script&lang=js"
import style0 from "./IconCalls.vue?vue&type=style&index=0&id=b6ad9716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ad9716",
  null
  
)

export default component.exports